/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：xr0F
 */

// removed by extract-text-webpack-plugin
module.exports = {
  "wrapper": "wrapper_1SK8O",
  "ready": "ready_3Gvez"
}

/***/
